var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemaleUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1457.83 1455.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #777;\n      }\n\n      .cls-2 {\n        fill: #e7e7e7;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #f0f0f0;\n      }\n\n      .cls-5 {\n        fill: #c2c2c2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1.41,
    y: -1.41,
    width: 1455.01,
    height: 1457.83,
    transform: "translate(1456.42 -1.41) rotate(90)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_2",
    "data-name": 2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 63.74,
    y: 76.8,
    width: 1307.88,
    height: 1307.88
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M895.48,888.44h-355.78s-110.44-186.9-101.26-384.46l557.92-1.6c9.14,197.56-100.88,386.05-100.88,386.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1291.2,1384.68H144.17c83.01-135.79,30.75-103.52,347.24-204.99,84.82-27.2,116.07-98.87,123.43-182.98,3.23-36.72,1.89-75.81-1.53-114.58h208.76c-4.53,51.21-5.39,102.93,3.03,149.06,12.6,68.84,45.89,125.12,118.83,148.5,316.53,101.47,264.23,69.19,347.28,204.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1291.21,1384.68H144.17c83.01-135.79,30.76-103.51,347.23-204.97,4.2-1.36,8.28-2.8,12.23-4.41,54.8,111.13,132.58,180.51,218.84,180.51s162.64-68.1,217.4-177.5c1.36.49,2.72.95,4.08,1.4,316.51,101.45,264.22,69.17,347.27,204.97Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M918.09,695.47c12.31-13.78,28.98-28.38,44.22-16.3,14.64,11.61,6.08,33.62,1.68,46.34-22.81,65.95-7.49,95.52-24.09,106.09-11.87,7.57-23.91-3.44-32.79-13.49,7.58-39.49,13.37-82.45,10.97-122.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M517.26,695.47c-12.31-13.78-28.98-28.38-44.22-16.3-14.64,11.61-6.08,33.62-1.68,46.34,22.81,65.95,7.49,95.52,24.09,106.09,11.87,7.57,23.91-3.44,32.79-13.49-7.58-39.49-13.37-82.45-10.97-122.65Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M825.1,1031.19c-25.98,23.62-58.41,35.11-90.68,35.11-40.62,0-81.4-18.14-109.3-55.69-3.58-4.8-7.01-9.45-10.27-13.89,3.23-36.72,1.89-75.81-1.53-114.58h208.76c-4.53,51.21-5.39,102.93,3.03,149.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M937.37,587.44c-18.04,273.78-4.47,258.81-110.38,401.51-27.91,37.57-68.72,55.73-109.31,55.73s-81.4-18.15-109.31-55.73c-105.91-142.69-92.34-127.73-110.38-401.51-9.23-142.87,90.55-243.37,219.69-243.37s228.92,100.5,219.69,243.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M944.93,664.53c16.07,26.79-16.42-14.49-27.55,82.39,15.23-178.47-137.33-101.63-290.16-240.01-110.38,55.19-110.51,160.5-110.51,238.61-10.83-90.25-43.85-55.96-27.75-82.14-37.3-53.03-119.41-206.16,63.66-334.87,198.17-40.76,122.37-42.74,330.1,0,183.27,128.88,99.85,282.91,62.21,336.03Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 717.68,
    cy: 285.28,
    rx: 195.58,
    ry: 160.58
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleUser);
export default __webpack_public_path__ + "static/media/femaleUser.d13e8f2491185df32979b99dd2a0a9dc.svg";
export { ForwardRef as ReactComponent };